// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: []
};

export default menuItems;
